export const newKeywordStyle = { backgroundColor: '#f3e8ff', color: '#7e22ce', fontWeight: 600 };

export const keywordKey = (value) => String(value).trim().replace(/\s+/g, ' ').toLowerCase();

// Keyword fields can arrive as arrays, serialized arrays, or comma/newline lists.
export function keywordValues(value) {
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return keywordValues(parsed);
    } catch { /* Plain keyword text. */ }
    return value.split(/[,\n]+/).map((item) => item.trim()).filter(Boolean);
  }
  if (!Array.isArray(value)) return [];
  return value.map((item) => typeof item === 'object' && item !== null
    ? item.keyword || item.text || item.value || '' : String(item ?? ''))
    .filter(Boolean);
}

export function keywordAdditions(suggestion) {
  const action = [suggestion.action_type, suggestion.lever, suggestion.apply?.field].filter(Boolean).join(' ');
  if (!/keyword/i.test(action) || /remove|pause|delete/i.test(action)
      || /remove|pause|delete/i.test(suggestion.apply?.operation || '')) return null;
  const current = new Set(keywordValues(suggestion.current_value).map(keywordKey));
  const skipped = new Set(keywordValues(suggestion.skipped_values).map(keywordKey));
  return new Set(keywordValues(suggestion.recommended_value)
    .map(keywordKey).filter((key) => !current.has(key) && !skipped.has(key)));
}
